<!-- ALERT & CONFIRM DIALOG -->
<p-toast></p-toast>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN CONTAINER -->
<div class="card" *ngIf="this.translations != null">

    <!-- TOOLBAR -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">

            <!-- BACK BUTTON -->
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>

            <!-- SAVE BUTTON -->
            <button pButton pRipple icon="pi pi-save" class="p-button-success p-mr-2"
                [pTooltip]="translations.lbl_add + ' ' + translations.lbl_or + ' ' + translations.lbl_update + ' ' + translations.lbl_documents"
                (click)="displayModalConfirmation=true"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">

        <!-- CREATE FORM -->
        <div class="p-col-12 p-md-6">
            <p-panel [header]="translations.lbl_detail + ' ' + translations.lbl_coordination">
                <div class="p-fluid">
                    <ng-container *ngTemplateOutlet="infoTemplateCreate"></ng-container>
                </div>
            </p-panel>
        </div>
    </div>

    <ng-template #infoTemplateCreate [formGroup]="globalUserDataFormParams">

        <!-- COORDINATION INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_coordination }}</span>
            <ng-container
                *ngIf="globalUserDataFormParams.get('selectedCoordination').value != null; else noSelectionCoordination">
                <span class="p-text-bold">
                    {{ globalUserDataFormParams.get('selectedCoordination').value || " " }}</span>
            </ng-container>

            <ng-template #noSelectionCoordination>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_coordination }}</span>
            </ng-template>
        </div>
    </ng-template>

    <!-- FORM TRANSFER -->
    <div class="card">

        <!-- TABLE -->
        <p-table #dt1 [value]="globalUserDataFormParams.get('selectedListProperties').value" [columns]="lstCols"
            *ngIf="globalUserDataFormParams.get('selectedListProperties').value != null" selectionMode="single"
            dataKey="property.id" [rows]="5" [paginator]="true" [rowsPerPageOptions]="[5, 10, 20]"
            [globalFilterFields]="['property.id','property.key','property.storeId','property.value']" [rowHover]="true"
            currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
            [showCurrentPageReport]="true" responsive="true" editMode="row">

            <!-- CAPTION -->
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-ai-center p-jc-between">
                    <h5 class="p-m-0">
                        {{ (translations.lbl_administration + ' ' + translations.lbl_for + ' ' +
                        translations.lbl_documents + ' ' + translations.lbl_of + ' ' +
                        translations.lbl_properties) | uppercase }}
                    </h5>


                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                            placeholder="{{translations.lbl_search}}..." />
                    </span>
                </div>

                <span class="p-input-icon-left">

                    <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-mr-2 z-5"
                        (click)="reloadGetListPropertiesDocuments()"></button>
                </span>
            </ng-template>

            <!-- HEADER -->
            <ng-template pTemplate="header">
                <tr>

                    <th colspan="2" pSortableColumn="property.key" pTooltip="{{ translations.lbl_key }}">
                        {{ translations.lbl_key }} <p-sortIcon field="property.key"></p-sortIcon>
                    </th>

                    <th colspan="2" pSortableColumn="property.value" pTooltip="{{ translations.lbl_value }}">
                        {{ translations.lbl_value }} <p-sortIcon field="property.value"></p-sortIcon>
                    </th>

                    <th pSortableColumn="property.storeId" pTooltip="{{ translations.lbl_storeId }}">
                        {{ translations.lbl_storeId }} <p-sortIcon field="property.storeId"></p-sortIcon>
                    </th>

                    <th pSortableColumn="store.descri" pTooltip="{{ translations.lbl_description }}">
                        {{ translations.lbl_description }} <p-sortIcon field="store.descri"></p-sortIcon>
                    </th>

                    <th pSortableColumn="store.countryId"
                        pTooltip="{{ translations.lbl_id + ' ' + translations.lbl_of + ' ' + translations.lbl_country}}">
                        {{ translations.lbl_id + ' ' + translations.lbl_of + ' ' + translations.lbl_country }}
                        <p-sortIcon field="store.countryId"></p-sortIcon>
                    </th>

                    <th pTooltip="{{ translations.lbl_options }}">
                        {{ translations.lbl_options }}
                    </th>
                </tr>
            </ng-template>

            <!-- BODY -->
            <ng-template pTemplate="body" let-data let-editing="editing" let-ri="rowIndex">
                <tr [pSelectableRow]="data" [pEditableRow]="data" [formGroup]="globalUserDataFormParams">


                    <td colspan="2"
                        pTooltip="{{ (data.property?.key || (translations.lbl_without + ' ' + translations.lbl_key)) | uppercase }}">
                        {{ (data.property?.key || (translations.lbl_without + ' ' + translations.lbl_key))
                        }}
                    </td>

                    <td colspan="2"
                        pTooltip="{{ (data.property?.value || (translations.lbl_without + ' ' + translations.lbl_value)) | uppercase }}">
                        <span *ngIf="!data.property?.value" class="p-badge p-badge-danger">
                            {{ (translations.lbl_without + ' ' + translations.lbl_value) }}
                        </span>

                        <span *ngIf="data.property?.value">
                            {{ (data.property?.value) | slice:0:100 }}
                            {{ (data.property?.value?.length > 100) ? '...' : '' }}
                        </span>
                    </td>

                    <td
                        pTooltip="{{ (data.property?.storeId || (translations.lbl_without + ' ' + translations.lbl_storeId)) | uppercase }}">

                        <span *ngIf="!data.property?.storeId" class="p-badge p-badge-danger">
                            {{ (translations.lbl_without + ' ' + translations.lbl_storeId) | uppercase }}
                        </span>
                        <span *ngIf="data.property?.storeId">
                            {{ (data.property?.storeId) }}
                        </span>
                    </td>

                    <td
                        pTooltip="{{ (data.store?.descri || (translations.lbl_without + ' ' + translations.lbl_description)) | uppercase }}">

                        <span *ngIf="!data.store?.descri" class="p-badge p-badge-danger">
                            {{ (translations.lbl_without + ' ' + translations.lbl_description) | uppercase }}
                        </span>
                        <span *ngIf="data.store?.descri">
                            {{ (data.store?.descri) }}
                        </span>
                    </td>

                    <td
                        pTooltip="{{ (data.store?.countryId || (translations.lbl_without + ' ' + translations.lbl_id + ' ' + translations.lbl_of + ' ' + translations.lbl_country)) | uppercase }}">

                        <span *ngIf="!data.store?.countryId" class="p-badge p-badge-danger">
                            {{ (translations.lbl_without + ' ' + translations.lbl_id + ' ' + translations.lbl_of + ' ' +
                            translations.lbl_country) | uppercase }}
                        </span>
                        <span *ngIf="data.store?.countryId">
                            {{ (data.store?.countryId | uppercase) }}
                        </span>
                    </td>


                    <td>
                        <!-- EDIT BUTTON -->
                        <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"
                            *ngIf="!editing" (click)="onRowEditInit(data)"></button>

                        <!-- CANCEL BUTTON -->
                        <button pButton pRipple pCancelEditableRow type="button" icon="pi pi-times"
                            class="p-button-rounded p-button-danger p-mr-2" *ngIf="editing"
                            (click)="onRowEditCancel(data, ri)"></button>

                        <!-- DELETE BUTTON -->
                        <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-mr-2"
                            (click)="deletePropertyDocument(data)" pTooltip="{{translations.lbl_delete}}"></button>
                    </td>
                </tr>

            </ng-template>

            <!-- EMPTY -->
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td [attr.colspan]="columns ? columns.length : 1">
                        {{translations.lbl_no_records_found}}
                    </td>
                </tr>
            </ng-template>

            <!-- SUMMARY -->
            <ng-template pTemplate="summary">
                <div class="p-d-flex">
                    <span class="p-mr-2">{{ translations.lbl_total }}</span>
                    <span class="p-text-bold p-mr-2">
                        {{ (globalUserDataFormParams.get('selectedListProperties').value).length || 0 }}
                    </span>
                    <span>{{ translations.lbl_records }}</span>
                </div>
            </ng-template>

        </p-table>
    </div>
</div>




<!-- CONFIRMATION DIALOG -->
<p-dialog [modal]="true" [closable]="true" (onHide)="onRowEditCancel()"
    [header]="translations.lbl_add + ' ' + translations.lbl_or + ' ' + translations.lbl_update + ' ' + translations.lbl_documents"
    [(visible)]="displayModalConfirmation" styleClass="p-fluid" [modal]="true" [style]="{width: '50vw'}"
    [maximizable]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false">

    <div class="card">

        <!-- MAIN CONTENT -->
        <div class="p-grid">
            <div class="p-col-12 p-md-12">
                <div class="p-fluid">
                    <ng-container *ngTemplateOutlet="infoTemplateCreate"></ng-container>
                </div>
            </div>
        </div>

        <ng-template #infoTemplateCreate [formGroup]="globalUserDataFormParams">

            <!-- COORDINATION INFO -->
            <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
                <span>{{ translations.lbl_coordination }}</span>
                <ng-container
                    *ngIf="globalUserDataFormParams.get('selectedCoordination').value != null; else noSelectionCoordination">
                    <span class="p-text-bold">
                        {{ globalUserDataFormParams.get('selectedCoordination').value || " " }}
                    </span>
                </ng-container>

                <ng-template #noSelectionCoordination>
                    <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_coordination
                        }}</span>
                </ng-template>
            </div>

            <!-- SEPARADOR -->
            <p-divider></p-divider>

            <!-- KEY INPUT -->
            <div class="p-col-12">
                <div class="p-formgrid p-grid p-ai-center p-jc-between">
                    <div class="subTitle p-col-12 p-md-4">
                        <span>{{translations.lbl_add + ' ' + translations.lbl_key }}<span
                                *ngIf="globalUserDataFormParams.get('selectedKey').value == null" style="color:red">
                                (*)</span></span>
                    </div>

                    <ng-container
                        *ngIf="globalUserDataFormParams.get('selectedUpdateProperties').value == null; else noSelectionKey">
                        <div class="p-col-12 p-md-8">
                            <input id="selectedKey" formControlName="selectedKey"
                                placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                pInputText>
                        </div>
                    </ng-container>

                    <ng-template #noSelectionKey>
                        <span class="p-text-bold">{{
                            globalUserDataFormParams.get('selectedUpdateProperties').value?.property?.key || ' '
                            }}</span>
                    </ng-template>
                </div>
            </div>

            <!-- STORE INPUT -->
            <div class="p-col-12">
                <div class="p-formgrid p-grid p-ai-center p-jc-between">
                    <div class="subTitle p-col-12 p-md-4">
                        <span>{{translations.lbl_add + ' ' + translations.lbl_storeId }}<span
                                *ngIf="globalUserDataFormParams.get('selectedStoreId').value == null" style="color:red">
                                (*)</span></span>
                    </div>

                    <ng-container
                        *ngIf="globalUserDataFormParams.get('selectedUpdateProperties').value == null; else noSelectionStoreId">
                        <div class="p-col-12 p-md-8">
                            <input id="selectedStoreId" formControlName="selectedStoreId"
                                placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                pInputText>
                        </div>
                    </ng-container>

                    <ng-template #noSelectionStoreId>
                        <span class="p-text-bold">{{
                            globalUserDataFormParams.get('selectedUpdateProperties').value?.property?.storeId || ' '
                            }}</span>
                    </ng-template>
                </div>
            </div>

            <!-- Comments -->
            <div class="p-col-12">
                <label for="commentsModal">{{translations.lbl_value}} <span
                        *ngIf="globalUserDataFormParams.get('selectedValue').value == null" style="color:red">
                        (*)</span></label>
                <textarea id="commentsModal" [formControl]="globalUserDataFormParams.get('selectedValue')" rows="5" [style.minHeight]="'3rem'"
                    cols="30" pInputTextarea autoResize="autoResize" maxlength="500" #myInput
                    placeholder="Ingrese valor de propiedad" ></textarea>
                <label class="nopadding clrlbl">{{myInput.value.length}} / 500</label>
            </div>

        </ng-template>
    </div>


    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="displayModalConfirmation=false"></button>

        <button pButton pRipple type="button" icon="pi pi-check"
            label="{{translations.lbl_save + ' / ' + translations.lbl_update}}" class="p-button-raised p-button-success"
            (click)="createUpdatePropertyDocument()"></button>
    </ng-template>
</p-dialog>